// !!! Must be in es5 syntax to i18next-scanner be able to work with it !!!
module.exports = {
  SUPPORTED_LANGUAGES: ['en', 'hu'],
  DEFAULT_LANGUAGE: 'hu',
};
